import api from './client';

export const getUsers = (params) => api.get('/users', { params }).then(r => r.data);
export const getFieldStaff = () => api.get('/users/field-staff').then(r => r.data);
export const getUser = (id) => api.get(`/users/${id}`).then(r => r.data);
export const createUser = (data) => api.post('/users', data).then(r => r.data);
export const updateUser = (id, data) => api.put(`/users/${id}`, data).then(r => r.data);
export const deactivateUser = (id) => api.patch(`/users/${id}/deactivate`).then(r => r.data);
export const activateUser   = (id) => api.patch(`/users/${id}/activate`).then(r => r.data);
export const deleteUser     = (id) => api.delete(`/users/${id}`).then(r => r.data);

// Sprint 2.8.5 T6-C: birincil şube ata/kaldır (backend PATCH /:id/primary-branch, T2 endpoint).
// primaryBranchId: UUID string veya null (atama kaldırmak için).
export const setUserPrimaryBranch = (id, primaryBranchId) =>
  api.patch(`/users/${id}/primary-branch`, { primary_branch_id: primaryBranchId }).then(r => r.data);
